// This file is generated by a script. Do not edit this file directly.
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from 'react';
export var Gift = function Gift(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#gift-a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M9.059 1.734A3.53 3.53 0 0 0 6.023 0h-.085a3.438 3.438 0 0 0-3.063 5h-1C.84 5 0 5.84 0 6.875v2.5a1.88 1.88 0 0 0 1.25 1.77V17.5c0 1.379 1.121 2.5 2.5 2.5h12.5c1.379 0 2.5-1.121 2.5-2.5v-6.355A1.88 1.88 0 0 0 20 9.375v-2.5C20 5.84 19.16 5 18.125 5h-1a3.44 3.44 0 0 0-3.062-5h-.086c-1.247 0-2.403.66-3.036 1.734L10 3.34l-.941-1.602zm9.066 5.141v2.5H11.25v-2.5h6.875m-9.375 0v2.5H1.875v-2.5H8.75m0 4.375v6.875h-5a.627.627 0 0 1-.625-.625v-6.25zm2.5 6.875V11.25h5.625v6.25a.627.627 0 0 1-.625.625zM14.063 5H11.2l1.359-2.312a1.65 1.65 0 0 1 1.418-.813h.085a1.562 1.562 0 1 1 0 3.125M8.75 5H5.938a1.562 1.562 0 1 1 0-3.125h.085c.582 0 1.125.309 1.418.813L8.801 5z"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "gift-a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 0h20v20H0z"
  }))));
};
